
import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Hero() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e8bbb1d39b9498755c89b1508120c741.jpg"
          alt="LaCrue Digital Agency Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-6 lg:px-12 pt-20">
        <div className="lg:w-[58%]">
          <div
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/15 rounded-full px-4 py-2 mb-8"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s, transform 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s',
            }}
          >
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span className="font-inter text-sm text-white/80">Now accepting new projects</span>
          </div>

          <h2
            className="font-sora text-5xl lg:text-[64px] text-white leading-[1.08] mb-7 font-bold tracking-tight"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(32px)',
              transition: 'opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.35s, transform 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.35s',
            }}
          >
            Websites that look premium — and bring in customers.
          </h2>
          
          <p
            className="font-inter text-lg text-white/70 leading-relaxed max-w-[520px] mb-10"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(28px)',
              transition: 'opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.5s, transform 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.5s',
            }}
          >
            LaCrue Digital Agency builds fast, mobile-first websites and local SEO foundations for businesses that want more calls, bookings, and customers.
          </p>

          <div
            className="flex flex-wrap items-center gap-4 mb-12"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.65s, transform 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.65s',
            }}
          >
            <Link
              to="/contact"
              className="bg-white text-charcoal px-9 py-4 rounded-xl font-inter font-semibold text-[15px] hover:bg-white/90 transition-all hover:shadow-lg hover:shadow-white/10 whitespace-nowrap cursor-pointer"
            >
              Book a Call
            </Link>
            <Link
              to="/pricing"
              className="border border-white/30 text-white px-9 py-4 rounded-xl font-inter font-medium text-[15px] hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              See Pricing
            </Link>
          </div>

          <div
            className="flex flex-wrap items-center gap-8"
            style={{
              opacity: isLoaded ? 1 : 0,
              transform: isLoaded ? 'translateY(0)' : 'translateY(20px)',
              transition: 'opacity 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.8s, transform 0.9s cubic-bezier(0.16, 1, 0.3, 1) 0.8s',
            }}
          >
            <div className="flex items-center gap-2.5">
              <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <i className="ri-check-line text-sm text-emerald-400"></i>
              </div>
              <span className="font-inter font-medium text-sm text-white/70 whitespace-nowrap">
                Fast turnaround (1–3 weeks)
              </span>
            </div>
            <div className="flex items-center gap-2.5">
              <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <i className="ri-check-line text-sm text-emerald-400"></i>
              </div>
              <span className="font-inter font-medium text-sm text-white/70 whitespace-nowrap">
                Mobile-first + SEO-ready
              </span>
            </div>
            <div className="flex items-center gap-2.5">
              <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <i className="ri-check-line text-sm text-emerald-400"></i>
              </div>
              <span className="font-inter font-medium text-sm text-white/70 whitespace-nowrap">
                Local, responsive support
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/40 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
